import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
const trackMXEvents = process.env.REACT_APP_MIXPANEL_TRACK === "true";

mixpanel.init(`${MIXPANEL_TOKEN}`, { debug: !trackMXEvents });

export const mxSigninEnterEmail = () => {
  // Triggered when a customer admin enters their email address during the sign-in process.
  mixpanel.track("ca_sign_enteremail");
};

export const mxSigninEnterPassword = () => {
  // Triggered when a customer admin enters their password during the sign-in process.
  mixpanel.track("ca_sign_enterpassword");
};

export const mxSigninSuccess = () => {
  // Triggered when a customer admin successfully signs in to the system.
  mixpanel.track("ca_sign_success");
};

export const mxSigninFail = () => {
  // Triggered when a customer admin fails to sign in to the system.
  mixpanel.track("ca_sign_failure");
};

export const mxDashboardLoad = () => {
  // Triggered when a customer admin lands on the dashboard page upon signing in.
  mixpanel.track("ca_dashboard_pageload");
};

export const mxReportPageLoad = () => {
  // Triggered when a customer admin lands on the reports page.
  mixpanel.track("ca_reports_pageload");
};

export const mxTargetManagementPageLoad = () => {
  // Triggered when a customer admin lands on the target management page.
  mixpanel.track("ca_targetmgmt_pageload");
};

export const mxLicenseManagementPageLoad = () => {
  // Triggered when a customer admin lands on the license management page.
  mixpanel.track("ca_license_pageload");
};

export const mxLicenseRequestCTAClick = () => {
  // Triggered when a customer admin clicks on request license button
  mixpanel.track("ca_license_request_cta_click");
};

export const mxLicenseRequestSuccess = (licenseCount, licenseType) => {
  //Triggered when a customer admin request a new license.
  mixpanel.track("ca_license_requestlicense_success", {
    "No of licenses count": licenseCount,
    "Type of licenses": licenseType
  });
};

export const mxSettingsPageLoad = () => {
  // Triggered when a customer admin lands on the settings page.
  mixpanel.track("ca_settings_pageload");
};

export const mxUserManagementPageLoad = () => {
  //Triggered when a customer admin lands on the user management page.
  mixpanel.track("ca_user_pageload");
};

export const mxAddUserSuccess = () => {
  //Triggered when a customer admin adds a new user.
  mixpanel.track("ca_user_add_success");
};

export const mxDeactivateUserSuccess = () => {
  //Triggered when a customer admin deactivates a user.
  mixpanel.track("ca_user_deactivate_success");
};

export const mcContactSupportSuccess = () => {
  //Triggered when a customer admin successfully contacts support.
  mixpanel.track("ca_support_success");
};
